import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { cookieData } from '../funciones/ConsultaUser';
import PostXls from '../shared/PostXls';
import PostXlsUpload from '../shared/PostXlsUpload';

export const ConsultaSemestres = (id, respuesta) => {
    let Content = {
        id: id,
    }
    Post(`${Url}consultSemestresDir`, Content, (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let contenido= [];

        for (let i in data) {
            contenido.push(
                { value: data[i].id, label: data[i].semestre_name }
            )
        }

        respuesta([contenido])
    });
}

export const ConsultaProfes = (string, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            strings: string,
        }

        Post(`${Url}consultProfDir`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });

    });
}

export const ConsultaProfesSem = (semestre, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            semestre: semestre
        }

        Post(`${Url}consultProfSemDir`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });

    });
}

export const ConsultAutoridades = (semestre, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: semestre
        }

        Post(`${Url}consultAutDir`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });

    });
}

export const ConsultaCortes = (respuesta) => {
    Post(`${Url}prefCortes`, "", (resp) => {
        let data = JSON.parse(resp);
        let corteHab = data[0];
        let porcentaje = data[1];
        
        let contenido = [];
        for (let i in corteHab) {
            let label = "";
            let codigo = "";
            let percent = 0;
            switch (i) {
                case "hab_corte_1":
                    label = 'Corte 1';
                    codigo = 'corte_1';
                    percent = porcentaje.p_corte_1;
                    break;
                case "hab_corte_2":
                    label = 'Corte 2';
                    codigo = 'corte_2';
                    percent = porcentaje.p_corte_2;
                    break;
                case "hab_corte_3":
                    label = 'Corte 3';
                    codigo = 'corte_3';
                    percent = porcentaje.p_corte_3;
                    break;
                case "hab_corte_4":
                    label = 'Corte 4';
                    codigo = 'corte_4';
                    percent = porcentaje.p_corte_4;
                    break;
                case "hab_corte_5":
                    label = 'Corte 5';
                    codigo = 'corte_5';
                    percent = porcentaje.p_corte_5;
                    break;
                default:
                    label = '';
                    codigo = "";
                    percent = 0;
                    break;
            }

            if (percent !== null) contenido.push(
                { value: i , label:`${label} - ${percent}%`, codigo: codigo }
            )            
        }

        respuesta(contenido)
    });
}


// WEBPACK FOOTER //
// ./src/funciones/CalifDirFunction.jsx